import React from 'react';
import { H2Alt } from 'scy/text';
import { secondary } from 'scy/text/styles.mod.scss';
import {
  listTitle,
  listItem,
  neighborhoodSection,
  neighborhoodList
} from './styles.mod.scss';

export default function Neighborhoods({ neighborhoods }) {
  if (!neighborhoods || !neighborhoods.length) return null;

  return (
    <section className={neighborhoodSection}>
      <H2Alt className={listTitle}>Neighborhoods We Deliver To</H2Alt>
      <ul className={neighborhoodList}>
        {neighborhoods.map(neighborhood => (
          <li key={neighborhood} className={`${secondary} ${listItem}`}>
            {neighborhood}
          </li>
        ))}
      </ul>
    </section>
  );
}
